import { T } from './orgTheme'
import { Skeleton } from '@/components/org/orgUi'

/**
 * The app's first loading screen (7 Oct 2026): the shell itself in skeleton — the real logo, a
 * grey organisation pill, the sidebar and a page — so the frame is there at once and only the
 * details fill in. It used to be a centred logo over a pulsing bar.
 */
export function ShellLoading() {
  return (
    <div role="status" aria-label="Loading" style={{ minHeight: '100vh', background: T.page, display: 'flex', flexDirection: 'column' }}>
      <div style={{ height: 60, display: 'flex', alignItems: 'center', gap: 14, padding: '0 20px', background: '#fff', borderBottom: `1px solid ${T.border}` }}>
        <img src="/learnbee-logo.png" alt="Learnbee" style={{ height: 24, width: 'auto' }} />
        <Skeleton w={170} h={30} r={9} />
        <span style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 14 }}><Skeleton w={90} h={12} /><Skeleton w={32} h={32} r={16} /></span>
      </div>
      <div style={{ flex: 1, display: 'flex' }}>
        <div className="hidden md:flex" style={{ width: 220, flexDirection: 'column', gap: 18, padding: '24px 18px', borderRight: `1px solid ${T.border}`, background: '#fff' }}>
          {[70, 82, 88, 64].map((w, i) => <span key={i} style={{ display: 'flex', alignItems: 'center', gap: 12 }}><Skeleton w={18} h={18} r={5} /><Skeleton w={w} h={12} /></span>)}
          <Skeleton w={60} h={10} style={{ marginTop: 14 }} />
          {[76, 80, 92, 66].map((w, i) => <span key={i} style={{ display: 'flex', alignItems: 'center', gap: 12 }}><Skeleton w={18} h={18} r={5} /><Skeleton w={w} h={12} /></span>)}
        </div>
        <div style={{ flex: 1, padding: '32px 32px', display: 'flex', flexDirection: 'column', gap: 24, maxWidth: 1180 }}>
          <Skeleton w={220} h={26} r={8} />
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 16 }}>
            {[0, 1, 2].map(i => <Skeleton key={i} h={150} r={16} />)}
          </div>
          <Skeleton h={220} r={16} />
        </div>
      </div>
    </div>
  )
}
